import { search_bcv } from './odoo.js'
import { dayjs } from '@/plugins/dayjs_intercom'
async function checkRouteBCV(route) {
    return await handle_search_bcv(route);
}
async function handle_search_bcv(route, fecha = null) {
    try {        
        const itemBCV = checkBcvStorage()
        if (itemBCV > 0) {
            return parseFloat(itemBCV);
        } else {
            if (route.meta.bcv === undefined ) {
                return await updateBCV(true, fecha, route);
            } else {
                if (route.meta.bcv !== undefined) {
                    return route.meta.bcv
                }
            }
        }
        console.log(itemBCV)
    } catch (err) {
        console.log(err)
    }
}
async function updateBCV(check = true, fecha = null, route = null) {
    if (fecha === null) {
        const currentDate = dayjs();
        fecha = currentDate.format('YYYY-MM-DD');
    }
    const currency_id = 2
    // const currency_id = route.meta.myCliente[0].currency_id
    const bcv_check = await search_bcv(currency_id, fecha);
    // console.log(bcv_check.rate_iverse)
    if (check) {
        checkBcvUsd(bcv_check.rate_iverse, route);
    } else {
        checkBcvStorage()
    }
    return bcv_check;
} 
function checkBcvStorage() {
    const createdAtString = localStorage.getItem('bcv_usd_createdAt')
    if (createdAtString) {
        const createdAt = new Date(createdAtString);
        const now = new Date();
        const timeDiff = now.getTime() - createdAt.getTime();
        const minutesDiff = timeDiff / (1000 * 60);                
        if (minutesDiff <= 30) { // AQUI SE DEFINE EL TIEMPO EN MINUTOS
            return localStorage.getItem('bcv_usd');
        } else {
            console.log("reset bcv")
            return 0;
        }
    } else {
        console.log("reset bcv")
        return 0;
    }
}
function checkBcvUsd(bcv_check, route) {
    console.log(bcv_check)
    if (bcv_check !== 0) {
        setLocalStorageItem('bcv_usd', bcv_check);
    } else {
        setTimeout(() => {
            handle_search_bcv(route);
        }, 30000);
    }
}
function setLocalStorageItem(key, value) {
    // Obtener la fecha actual
    const createdAt = new Date().toISOString();
    // Guardar el elemento y la fecha de creación
    localStorage.setItem(key, value);
    localStorage.setItem(`${key}_createdAt`, createdAt);
}

export {
    checkRouteBCV, updateBCV
}
